import VueRouter from 'vue-router';
import ROLES from 'config/roles';

const route = [
    {
        path: '',
        component: () => import('views/layout/Dashboard'),
        meta: {
            auth: true
        },
        children: [
            {
                path: '/',
                name: 'dashboard',
                component: () => import('views/dashboard/Index'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.ssp_feed, ROLES.dsp_external, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/statistics',
                name: 'statistics',
                component: () => import('views/statistics/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/statistics/v2',
                name: 'statistics/v2',
                component: () => import('views/statistics/ListV2'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.client, 
                                ROLES.advertiser, ROLES.responsible_manager, ROLES.support, ROLES.ssp_feed]
                    }
                }
            },
            {
                path: '/statistics-grouped-by-ad',
                name: 'statistics-grouped-by-ad',
                component: () => import('views/statistics/GroupedByAd'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/reconciliation-statistic',
                name: 'reconciliation-statistic',
                component: () => import('views/statistics/ReconciliationStatistic'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.dsp_external]
                    }
                }
            },
            {
                path: '/expense',
                name: 'stats-users',
                component: () => import('views/statistics/ListUsers'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/integrations/expense',
                name: 'stats-integrations',
                component: () => import('views/statistics/ListIntegrations'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ssp-groups',
                name: 'ssp-groups',
                component: () => import('views/sspGroups/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ssp-groups/:id',
                name: 'ssp-group-edit',
                component: () => import('views/sspGroups/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/ssp-groups-groups-stat',
                name: 'ssp-groups-groups-stat',
                component: () => import('views/sspGroupsGroupsStat/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ssp-groups-groups-stat/create',
                name: 'ssp-group-group-stat-create',
                component: () => import('views/sspGroupsGroupsStat/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ssp-groups-group-stat/:id',
                name: 'ssp-group-group-stat-edit',
                component: () => import('views/sspGroupsGroupsStat/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/ssp-pixels',
                name: 'ssp-pixelss',
                component: () => import('views/sspPixels/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ssp-pixels/create',
                name: 'ssp-pixel-create',
                component: () => import('views/sspPixels/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ssp-pixels/:id',
                name: 'ssp-pixel-edit',
                component: () => import('views/sspPixels/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/ssp-types',
                name: 'sspTypes',
                component: () => import('views/sspTypes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ssp-types/create',
                name: 'ssp-type-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/sspTypes/Create')
            },
            {
                path: '/ssp-types-commission',
                name: 'ssp-types-commission',
                component: () => import('views/sspTypes/Commission'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/buying-type-coeff/create',
                name: 'buying-type-coeff-create',
                component: () => import('views/buyingTypeCoeffs/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },
            {
                path: '/buying-type-coeff/:sspId',
                name: 'buying-type-coeffs',
                component: () => import('views/buyingTypeCoeffs/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },
            {
                path: '/top-blocks/:sspId',
                name: 'top-blocks',
                component: () => import('views/sspTypes/TopBlocks'),
                props: true
            },
            {
                path: '/load/ssp',
                name: 'sspLoadList',
                component: () => import('views/load/SspList'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/load/dsp',
                name: 'dspLoadList',
                component: () => import('views/load/DspList'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            // Рассчет коэффов микробиддинга
            {
                path: '/microbidding-calc-jobs',
                name: 'microbidding-calc-jobs',
                component: () => import('views/microbiddingCalcJobs/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/microbidding-calc-jobs/create',
                name: 'microbidding-calc-jobs-create',
                component: () => import('views/microbiddingCalcJobs/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/microbidding-calc-jobs/:id',
                name: 'microbidding-calc-jobs-edit',
                component: () => import('views/microbiddingCalcJobs/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },


            {
                path: '/microbidding-calc-jobs/sites/log/:id',
                name: 'microbidding-calc-jobs-sites-log',
                component: () => import('views/microbiddingCalcJobs/Sites/Log'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true                
            },           
           
            {
                path: '/microbidding-calc-jobs/subscription-days/log/:id',
                name: 'microbidding-calc-jobs-subDays-log',
                component: () => import('views/microbiddingCalcJobs/SubscriptionDays/Log'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },            

            {
                path: '/microbidding-calc-jobs/campaigns/log/:id',
                name: 'microbidding-calc-jobs-campaigns-log',
                component: () => import('views/microbiddingCalcJobs/Campaigns/Log'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true                
            },           

            {
                path: '/settings-it',
                name: 'settings-it',
                component: () => import('views/settings/IT/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settings-it/create',
                name: 'settings-it-create',
                component: () => import('views/settings/IT/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settings-it/:id',
                name: 'settings-it-edit',
                component: () => import('views/settings/IT/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/settingsRTBBalance',
                name: 'settingsRTBBalance',
                component: () => import('views/settings/Common/Balance'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    },
                    type: 'pp'
                }
            },

            {
                path: '/settingsGRBalance',
                name: 'settingsGRBalance',
                component: () => import('views/settings/Common/Balance'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    },
                    type: 'gr'
                }
            },
            {
                path: '/settingsCommonSettings',
                name: 'settingsCommonSettings',
                component: () => import('views/settings/Common/Common'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsGRSettings',
                name: 'settingsGRSettings',
                component: () => import('views/settings/GR/GR'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsPushSettings',
                name: 'settingsPushSettings',
                component: () => import('views/settings/Push/Push'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsPopupSettings',
                name: 'settingsPopupSettings',
                component: () => import('views/settings/Popup/Popup'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsML',
                name: 'settingsML',
                component: () => import('views/settings/MachineLearning/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsMlPush',
                name: 'settingsMLPush',
                component: () => import('views/settings/MachineLearningPush/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsMlExternalPush',
                name: 'settingsMLPush',
                component: () => import('views/settings/MachineLearningExternalPush/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsMlExternalNative',
                name: 'settingsMLExternalNative',
                component: () => import('views/settings/MachineLearningExternalNative/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/ml-threshold',
                name: 'ml-threshold',
                component: () => import('views/machineLearning/Threshold/Native/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ml-threshold/create',
                name: 'ml-threshold-create',
                component: () => import('views/machineLearning/Threshold/Native/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ml-threshold/:id',
                name: 'ml-threshold-edit',
                component: () => import('views/machineLearning/Threshold/Native/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/ml-threshold-push',
                name: 'ml-threshold-push',
                component: () => import('views/machineLearning/Threshold/Push/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ml-threshold-push/create',
                name: 'ml-threshold-push-create',
                component: () => import('views/machineLearning/Threshold/Push/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ml-threshold-push/:id',
                name: 'ml-threshold-push-edit',
                component: () => import('views/machineLearning/Threshold/Push/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/ml-snapshots',
                name: 'ml-snapshots',
                component: () => import('views/settings/MachineLearningSnapshots/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/settingsCpmCoefficientCalculator',
                name: 'settingsCpmCoefficientCalculator',
                component: () => import('views/settings/CpmCoefficientCalculator/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

             {
                path: '/settings/news-tag-ctr-coeff',
                name: 'news-tag-ctr-coeff',
                component: () => import('views/settings/NewsTagCtrCoeff/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/settings-dsp-rate-limit',
                name: 'settings-dsp-rate-limit',
                component: () => import('views/settings/DspRateLimitCalculator/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settings-cpa-acceleration',
                name: 'settings-cpa-acceleration',
                component: () => import('views/settings/CpaAcceleration/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settings-cpa-popup',
                name: 'settings-cpa-popup',
                component: () => import('views/settings/CpaPopup/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsNormalizationCoeffML',
                name: 'settingsMLnormalizationCoeff',
                component: () => import('views/settings/MLnormalizationCoeff/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsSiteCoeffPush',
                name: 'settingsSiteCoeffPush',
                component: () => import('views/settings/SiteCoeffPush/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsActiveSiteGroup',
                name: 'settingsActiveSiteGroup',
                component: () => import('views/settings/ActiveSiteGroup/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsTeaserBuying',
                name: 'settingsTeaserBuying',
                component: () => import('views/settings/TeaserBuying/Page'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsTeaserBuying/countries/Create',
                name: 'teaser-buying-dashboard-country-create',
                component: () => import('views/settings/TeaserBuying/countries/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsTeaserBuying/countries/Edit/:id',
                name: 'teaser-buying-dashboard-country-edit',
                component: () => import('views/settings/TeaserBuying/countries/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsDspRequest',
                name: 'settingsDspRequest',
                component: () => import('views/settings/DspRequest/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsDspRequest/create',
                name: 'settingsDspRequest-create',
                component: () => import('views/settings/DspRequest/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settingsDspRequest/edit/:id',
                name: 'settingsDspRequest-edit',
                component: () => import('views/settings/DspRequest/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/settings/traffic-volumes',
                name: 'settings-traffic-volumes',
                component: () => import('views/settings/TrafficVolumes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/settings/traffic-volumes/:id',
                name: 'settings-traffic-volumes-edit',
                component: () => import('views/settings/TrafficVolumes/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/profile',
                name: 'profile',
                component: () => import('views/profile/Index')
            },

            {
                path: '/payouts',
                name: 'payouts',
                component: () => import('views/payouts/Index'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.ssp_feed]
                    }
                }
            },
            {
                path: '/payouts-statistic',
                name: 'payouts',
                component: () => import('views/payouts/Index'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.ssp_feed]
                    }
                }
            },

            {
                path: '/campaigns',
                name: 'campaigns',
                component: () => import('views/campaigns/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/campaigns/create',
                name: 'campaign-create',
                component: () => import('views/campaigns/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/campaigns/:id',
                name: 'campaign-edit',
                component: () => import('views/campaigns/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/campaigns/:id/rating',
                name: 'campaign-rating',
                component: () => import('views/campaigns/Rating'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },

            // Cabinet popups.
            {
                path: '/cabinet-popups',
                name: 'cabinet-popups',
                component: () => import('views/cabinetPopups/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cabinet-popups/create',
                name: 'cabinet-popup-create',
                component: () => import('views/cabinetPopups/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cabinet-popups/edit/:id',
                name: 'cabinet-popup-edit',
                component: () => import('views/cabinetPopups/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

            {
                path: '/categories',
                name: 'categories',
                component: () => import('views/categories/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/categories/create',
                name: 'categories-create',
                component: () => import('views/categories/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/categories/:id',
                name: 'category-edit',
                component: () => import('views/categories/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/items',
                name: 'ads',
                component: () => import('views/ads/List'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/item/create',
                name: 'ad-create',
                component: () => import('views/ads/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/item/:id',
                name: 'ad-edit',
                component: () => import('views/ads/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/ad-prices',
                name: 'ad-prices',
                component: () => import('views/ads/Prices'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser]
                    }
                },
                props: true
            },
            {
                path: '/ad/:id/logs',
                name: 'ad-logs',
                component: () => import('views/ads/Logs'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            // ОРД
            {
                path: '/ord/organizations',
                name: 'organizations',
                component: () => import('views/ord/Organizations/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/organization-create',
                name: 'organization-create',
                component: () => import('views/ord/Organizations/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/organization-edit/:id',
                name: 'organization-edit',
                component: () => import('views/ord/Organizations/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/organization/:id/platforms',
                name: 'organization-platforms',
                component: () => import('views/ord/Organizations/Platforms'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

            {
                path: '/ord/contracts',
                name: 'contracts',
                component: () => import('views/ord/Contracts/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/contract-create',
                name: 'contract-create',
                component: () => import('views/ord/Contracts/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/contract-edit/:id',
                name: 'contract-edit',
                component: () => import('views/ord/Contracts/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

            {
                path: '/ord/platforms',
                name: 'platforms',
                component: () => import('views/ord/Platforms/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/platform-create',
                name: 'platform-create',
                component: () => import('views/ord/Platforms/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/platform-edit/:id',
                name: 'platform-edit',
                component: () => import('views/ord/Platforms/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

            {
                path: '/ord/invoices',
                name: 'invoices',
                component: () => import('views/ord/Invoices/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/invoice-show/:id',
                name: 'invoice-show',
                component: () => import('views/ord/Invoices/Show'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/invoice-create',
                name: 'invoice-create-index',
                component: () => import('views/ord/Invoices/CreateIndex'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/invoice-edit/:id',
                name: 'invoice-edit',
                component: () => import('views/ord/Invoices/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/ord/invoice-attr/:id',
                name: 'invoice-attr',
                component: () => import('views/ord/Invoices/AttributesIndex'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

            {
                path: '/banners',
                name: 'banners',
                component: () => import('views/banners/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/banners-create/:id',
                name: 'banner-create',
                component: () => import('views/banners/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/banners-edit/:id',
                name: 'banner-edit',
                component: () => import('views/banners/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/epc',
                name: 'epc',
                component: () => import('views/topsEpc/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/epc/create',
                name: 'epc-create',
                component: () => import('views/topsEpc/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
            {
                path: '/epc/:id',
                name: 'epc-edit',
                component: () => import('views/topsEpc/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
            {
                path: '/epc/:id/coeffs',
                name: 'epc-coeffs',
                component: () => import('views/topsEpc/Coeffs'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/users',
                name: 'users',
                component: () => import('views/users/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/users/:id',
                name: 'user-edit',
                component: () => import('views/users/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.responsible_manager, ROLES.support]
                    }
                },
                props: true
            },
            {
                path: '/users/:id/reset-password',
                name: 'user-reset',
                component: () => import('views/users/ResetPassword'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.responsible_manager, ROLES.support]
                    }
                },
                props: true
            },

            {
                path: '/browsers',
                name: 'browsers',
                component: () => import('views/browsers/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/browsers/create',
                name: 'browser-create',
                component: () => import('views/browsers/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/browsers/:id',
                name: 'browser-edit',
                component: () => import('views/browsers/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/countries',
                name: 'countries',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/countries/List')
            },
            {
                path: '/countries/create',
                name: 'country-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/countries/Create')
            },
            {
                path: '/countries/:id',
                name: 'country-edit',
                component: () => import('views/countries/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
                        {
                path: '/countries-whitelist',
                name: 'countries-whitelist',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/countries/WhiteList')
            },

            {
                path: '/regions',
                name: 'regions',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/regions/List')
            },
            {
                path: '/regions/:id',
                name: 'region-edit',
                component: () => import('views/regions/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/languages',
                name: 'languages',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/languages/List')
            },
            {
                path: '/languages/create',
                name: 'language-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/languages/Create')
            },
            {
                path: '/languages/:id',
                name: 'language-edit',
                component: () => import('views/languages/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/connection-types',
                name: 'connection-types',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/connectionTypes/List')
            },
            {
                path: '/connection-types/create',
                name: 'connection-types-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/connectionTypes/Create')
            },
            {
                path: '/connection-types/:id',
                name: 'connection-types-edit',
                component: () => import('views/connectionTypes/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/connection-type-groups',
                name: 'connection-type-groups',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/connectionTypeGroups/List')
            },
            {
                path: '/connection-type-group/create',
                name: 'connection-type-group-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/connectionTypeGroups/Create')
            },
            {
                path: '/connection-type-group/:id',
                name: 'connection-type-group-edit',
                component: () => import('views/connectionTypeGroups/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/ssp-tokens',
                name: 'ssp-types',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/sspTokens/List')
            },
            {
                path: '/ssp-tokens/create',
                name: 'ssp-token-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/sspTokens/Create')
            },
            {
                path: '/ssp-tokens/:id',
                name: 'ssp-token-edit',
                component: () => import('views/sspTokens/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/optional-stat-fields',
                name: 'optional-stat-fields',
                component: () => import('views/optionalStatFields/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/optional-stat-fields/create',
                name: 'optional-stat-field-create',
                component: () => import('views/optionalStatFields/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/optional-stat-fields/:id',
                name: 'optional-stat-field-edit',
                component: () => import('views/optionalStatFields/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            // Домены изображений
            {
                path: '/imagedomains',
                name: 'imagedomains',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/imagedomains/List')
            },
            {
                path: '/imagedomains/create',
                name: 'imagedomain-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/imagedomains/Create')
            },
            {
                path: '/imagedomains/:id',
                name: 'imagedomain-edit',
                component: () => import('views/imagedomains/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            // Домены видео
            {
                path: '/videodomains',
                name: 'videodomains',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/videodomains/List')
            },
            {
                path: '/videodomains/create',
                name: 'videodomain-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/videodomains/Create')
            },
            {
                path: '/videodomains/:id',
                name: 'videodomain-edit',
                component: () => import('views/videodomains/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            // Домены трекера
            {
                path: '/trackerdomains',
                name: 'trackerdomains',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/trackerdomains/List')
            },
            {
                path: '/trackerdomains/create',
                name: 'trackerdomain-create',
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                component: () => import('views/trackerdomains/Create')
            },
            {
                path: '/trackerdomains/:id',
                name: 'trackerdomain-edit',
                component: () => import('views/trackerdomains/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
            {
                path: '/devicetypes',
                name: 'devicetypes',
                component: () => import('views/devicetypes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/devicetypes/create',
                name: 'devicetype-create',
                component: () => import('views/devicetypes/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/devicetypes/:id',
                name: 'devicetype-edit',
                component: () => import('views/devicetypes/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
            {
                path: '/devicemodels',
                name: 'devicemodels',
                component: () => import('views/devicemodels/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/devicemodels/create',
                name: 'devicemodels-create',
                component: () => import('views/devicemodels/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/devicemodels/:id',
                name: 'devicemodels-edit',
                component: () => import('views/devicemodels/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/campaign-site-black-settings',
                name: 'campaign-site-black-settings',
                component: () => import('views/campaignSiteBlackSettings/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/campaign-site-black-settings/create',
                name: 'campaign-site-black-settings-create',
                component: () => import('views/campaignSiteBlackSettings/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/auditories',
                name: 'auditories',
                component: () => import('views/auditories/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            // {
            //     path: '/auditories/create',
            //     name: 'auditory-create',
            //     component: () => import('views/auditories/Create')
            // },

            // {
            //     path: '/auditories/:id',
            //     name: 'auditory-edit',
            //     component: () => import('views/auditories/Edit'),
            //     props: true
            // },

            {
                path: '/adat/:id',
                name: 'abtestad',
                component: () => import('views/abtestAd/Abtest'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser]
                    }
                },
                props: true
            },
            {
                path: '/adat/createedit/:adid/:tid',
                name: 'abtestad-createedit',
                component: () => import('views/abtestAd/CreateEdit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser]
                    }
                },
                props: true
            },
            {
                path: '/adats',
                name: 'abtestsad',
                component: () => import('views/abtestAd/Abtest'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/ads-external-dsp',
                name: 'ads-external-dsp',
                component: () => import('views/adsExternalDsp/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },

            {
                path: '/abtest/:id',
                name: 'abtest',
                component: () => import('views/abtest/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
            {
                path: '/abtest/createedit/:tid',
                name: 'abtest-createedit',
                component: () => import('views/abtest/CreateEdit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
            {
                path: '/abtests',
                name: 'abtests',
                component: () => import('views/abtest/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },

            {
                path: '/dsptypes',
                name: 'dsptypes',
                component: () => import('views/dsptypes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/dsptypes/:id',
                name: 'dsptype-edit',
                component: () => import('views/dsptypes/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },
            {
                path: '/fees',
                name: 'fees',
                component: () => import('views/fees/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/fees/create',
                name: 'fee-create',
                component: () => import('views/fees/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/fees/:id',
                name: 'fee-edit',
                component: () => import('views/fees/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },
            {
                path: '/content-quality/ad-tags',
                name: 'adTags',
                component: () => import('views/contentQuality/adTags/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/content-quality/ad-tags/create',
                name: 'adTag-create',
                component: () => import('views/contentQuality/adTags/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/content-quality/ad-tags/:id',
                name: 'adTag-edit',
                component: () => import('views/contentQuality/adTags/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },
            {
                path: '/content-quality/ad-tag-category',
                name: 'adTagCategories',
                component: () => import('views/contentQuality/adTagCategories/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/content-quality/ad-tag-categories/create',
                name: 'adTagCategory-create',
                component: () => import('views/contentQuality/adTagCategories/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/content-quality/ad-tag-categories/:id',
                name: 'adTagCategory-edit',
                component: () => import('views/contentQuality/adTagCategories/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },
            {
                path: '/content-quality/keyword-ad-tags',
                name: 'keywordAdTags',
                component: () => import('views/contentQuality/keywordAdTags/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/content-quality/keyword-ad-tags/create',
                name: 'keywordAdTags-create',
                component: () => import('views/contentQuality/keywordAdTags/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/metrics/campaigns',
                name: 'metrics-campaigns',
                component: () => import('views/metrics/campaigns/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/metrics/ads',
                name: 'metrics-ads',
                component: () => import('views/metrics/ads/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/metrics/timely-update',
                name: 'timely-update',
                component: () => import('views/metrics/timelyUpdate/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/metrics/ab-test-ads',
                name: 'metrics-ab-test-ads',
                component: () => import('views/metrics/abTestAds/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/metrics/accelerate-ads',
                name: 'metrics-accelerate-ads',
                component: () => import('views/metrics/accelerateAds/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/metrics/active-site-group',
                name: 'active-site-group',
                component: () => import('views/metrics/activeSiteGroup/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/metrics/ssp',
                name: 'metrics-ssp',
                component: () => import('views/metrics/ssp/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/new-sites',
                name: 'new-sites',
                component: () => import('views/metrics/newSites/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/block-click-cheaters',
                name: 'blockClickCheaters',
                component: () => import('views/blockClickCheaters/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/payments-report',
                name: 'payments-report',
                component: () => import('views/paymentsReport/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/payments-report-users',
                name: 'feesUsers',
                component: () => import('views/paymentsReport/ListUsers'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/balances-comparison',
                name: 'feesUsers',
                component: () => import('views/paymentsReport/BalancesComparison'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/products-comparison',
                name: 'products-comparison',
                component: () => import('views/statistics/ProductsComparison'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/forecast-cpm',
                name: 'forecast-cpm',
                component: () => import('views/cpm/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/recommendation-price-check',
                name: 'recommendation-price-check',
                component: () => import('views/recommendationPriceCheck/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/recommendation-price-check/countries',
                name: 'recommendation-price-check-countries',
                component: () => import('views/recommendationPriceCheck/Countries'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/images-compare',
                name: 'images-compare',
                component: () => import('views/images/Compare'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/dmp-analyze',
                name: 'dmp-analyze',
                component: () => import('views/dmpAnalyze/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/antifrod',
                name: 'antifrod',
                component: () => import('views/antifrod/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/site-banned',
                name: 'site-banned',
                component: () => import('views/antifrod/ListBanned'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/site-banned-stat-logs',
                name: 'site-banned-stat-logs',
                component: () => import('views/antifrod/ListBannedStatLogs'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/site-allowed-stat-logs',
                name: 'site-allowed-stat-logs',
                component: () => import('views/antifrod/ListAllowedStatLogs'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/antifrod-analyze',
                name: 'antifrod-analyze',
                component: () => import('views/antifrodAnalyze/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/user-compensation',
                name: 'user-compensation',
                component: () => import('views/userCompensation/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/antifrod-metrics',
                name: 'antifrod-metrics',
                component: () => import('views/antifrod/ListMetrics'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/site-banned/settings',
                name: 'site-banned-settings',
                component: () => import('views/antifrod/siteBannedSettings/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/site-banned/settings/:id',
                name: 'site-banned-settings-edit',
                component: () => import('views/antifrod/siteBannedSettings/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/suspicious-types/settings',
                name: 'suspicious-types-settings',
                component: () => import('views/antifrod/suspiciousTypes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/suspicious-types/settings/:id',
                name: 'suspicious-types-settings-edit',
                component: () => import('views/antifrod/suspiciousTypes/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/events',
                name: 'events',
                component: () => import('views/events/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.advertiser]
                    }
                }
            },
            {
                path: '/events/:unit/:id',
                name: 'unit-events',
                component: () => import('views/events/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                },
                props: true
            },
            {
                path: '/financial-logs',
                name: 'financial-logs',
                component: () => import('views/financialLogs/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/transit-balance',
                name: 'transit-balance',
                component: () => import('views/financialLogs/TransitBalance'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/user-balance',
                name: 'user-balance',
                component: () => import('views/financialLogs/UserBalance'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/financial-brand-type-reports',
                name: 'financial-brand-type-reports',
                component: () => import('views/financialBrandTypeReports/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/accounting-campaigns',
                name: 'accounting-campaigns',
                component: () => import('views/accounting/Campaigns'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/accounting-campaigns-push',
                name: 'accounting-campaigns-push',
                component: () => import('views/accounting/CampaignsPush'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/accounting-return',
                name: 'accounting-return',
                component: () => import('views/accounting/ReturnUsers'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/accounting-tags',
                name: 'accounting-tags',
                component: () => import('views/accounting/Tags'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/accounting-user-expenses',
                name: 'accounting-user-expenses',
                component: () => import('views/accounting/UserExpense'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },

            {
                path: '/algoritms',
                name: 'algoritms',
                component: () => import('views/algoritms/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/siteStatuses',
                name: 'siteStatuses',
                component: () => import('views/settings/Sites'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },

            {
                path: '/buying-types',
                name: 'buyingTypes',
                component: () => import('views/buyingTypes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/buying-types/create',
                name: 'buying-type-create',
                component: () => import('views/buyingTypes/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/buying-types/:id',
                name: 'buying-type-edit',
                component: () => import('views/buyingTypes/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            {
                path: '/rtb-domains',
                name: 'rtbDomains',
                component: () => import('views/rtbDomains/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/rtb-domains/create',
                name: 'rtb-domain-create',
                component: () => import('views/rtbDomains/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/rtb-domains/:id',
                name: 'rtb-domain-edit',
                component: () => import('views/rtbDomains/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            {
                path: '/change-domain',
                name: 'change-domain',
                component: () => import('views/ads/changeDomain/ChangeDomain'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/change-domain-many',
                name: 'change-domain-many',
                component: () => import('views/ads/changeDomain/ChangeDomainMany'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/change-domain-news',
                name: 'change-domain-news',
                component: () => import('views/ads/changeDomain/ChangeDomainNews'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/alerts-management',
                name: 'alerts-management',
                component: () => import('views/alertsManagement/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/alerts-management/create',
                name: 'alerts-management-create',
                component: () => import('views/alertsManagement/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/alerts-management/:id',
                name: 'alerts-management-edit',
                component: () => import('views/alertsManagement/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },


            // Причины отклонений
            {
                path: '/decline-reasons',
                name: 'decline-reasons',
                component: () => import('views/declineReasons/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/decline-reasons/create',
                name: 'decline-reason-create',
                component: () => import('views/declineReasons/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/brand-types/:id',
                name: 'decline-reason-edit',
                component: () => import('views/declineReasons/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                },
                props: true
            },

            // Statuses
            {
                path: '/active-statuses',
                name: 'activeStatuses',
                component: () => import('views/activeStatuses/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/active-statuses/create',
                name: 'status-create',
                component: () => import('views/activeStatuses/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/active-statuses/:id',
                name: 'status-edit',
                component: () => import('views/activeStatuses/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },


            // ModerationStatuses
            {
                path: '/moderation-statuses',
                name: 'moderationStatuses',
                component: () => import('views/moderationStatuses/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/moderation-statuses/create',
                name: 'moderation-status-create',
                component: () => import('views/moderationStatuses/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/moderation-statuses/:id',
                name: 'moderation-status-edit',
                component: () => import('views/moderationStatuses/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            // BalanceStatuses
            {
                path: '/balance-statuses',
                name: 'balanceStatuses',
                component: () => import('views/balanceStatuses/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/balance-statuses/create',
                name: 'balance-status-create',
                component: () => import('views/balanceStatuses/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/balance-statuses/:id',
                name: 'balance-status-edit',
                component: () => import('views/balanceStatuses/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            // AccelerateStatuses
            {
                path: '/accelerate-statuses',
                name: 'accelerateStatuses',
                component: () => import('views/accelerateStatuses/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/accelerate-statuses/create',
                name: 'accelerate-status-create',
                component: () => import('views/accelerateStatuses/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/accelerate-statuses/:id',
                name: 'accelerate-status-edit',
                component: () => import('views/accelerateStatuses/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            // TimeRangeStauses
            {
                path: '/time-range-statuses',
                name: 'timeRangeStatuses',
                component: () => import('views/timeRangeStatuses/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/time-range-statuses/create',
                name: 'time-range-status-create',
                component: () => import('views/timeRangeStatuses/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/time-range-statuses/:id',
                name: 'time-range-status-edit',
                component: () => import('views/timeRangeStatuses/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            // AdCpaStatuses
            {
                path: '/ad-cpa-statuses',
                name: 'ad-cpa-statuses',
                component: () => import('views/adCpaStatuses/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ad-cpa-statuses/create',
                name: 'ad-cpa-status-create',
                component: () => import('views/adCpaStatuses/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/ad-cpa-statuses/:id',
                name: 'ad-cpa-status-edit',
                component: () => import('views/adCpaStatuses/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            // CampaignCpaStatuses
            {
                path: '/campaign-cpa-statuses',
                name: 'campaign-cpa-statuses',
                component: () => import('views/campaignCpaStatuses/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/campaign-cpa-statuses/create',
                name: 'campaign-cpa-status-create',
                component: () => import('views/campaignCpaStatuses/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/campaign-cpa-statuses/:id',
                name: 'campaign-cpa-status-edit',
                component: () => import('views/campaignCpaStatuses/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            // ContentTypes
            {
                path: '/content-types',
                name: 'contentTypes',
                component: () => import('views/contentTypes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            // -- ContentTypes

            {
                path: '/blockCpmCoefficient',
                name: 'block-cpm-coefficient-edit',
                component: () => import('views/blockCpmCoefficients/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/site-coefficients-push',
                name: 'site-coefficients-push',
                component: () => import('views/siteCoefficientsPush/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator, ROLES.cmoderator]
                    }
                }
            },
            {
                path: '/attribute-coefficients',
                name: 'attribute-coefficients',
                component: () => import('views/attributeCoefficients/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/site-adtag-coefficients',
                name: 'site-adtag-coefficients',
                component: () => import('views/siteAdTagCoefficients/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/adDisabling',
                name: 'ad-disabling-edit',
                component: () => import('views/adDisabling/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/incorrect-source-estimate',
                name: 'incorrect-source-estimate',
                component: () => import('views/incorrectSourceEstimate/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            // Payment
            {
                path: '/payment/success',
                name: 'payment-success',
                component: () => import('views/profile/payment/Success')
            },
            {
                path: '/payment/fail',
                name: 'payment-fail',
                component: () => import('views/profile/payment/Fail')
            },

            // Debugging
            {
                path: '/debugging/page/native',
                name: 'debugging-page-native',
                component: () => import('src/views/debugging/PageNative'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/debugging/page/banner',
                name: 'debugging-page-banner',
                component: () => import('src/views/debugging/PageBanner'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/ml',
                name: 'debugging-page-ml',
                component: () => import('src/views/debugging/ML'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/debugging/ml-push',
                name: 'debugging-page-ml-push',
                component: () => import('src/views/debugging/MLPush'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/debugging/ml-push-avg-ctr',
                name: 'debugging-page-ml-push-avg-ctr',
                component: () => import('src/views/debugging/MLPushAvgCtr'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.advertiser, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/debugging/ml-external-push',
                name: 'debugging-page-ml-external-push',
                component: () => import('src/views/debugging/MLExternalPush'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.advertiser]
                    }
                }
            },
            {
                path: '/debugging/ml-external-native',
                name: 'debugging-page-ml-external-native',
                component: () => import('src/views/debugging/MLExternalNative'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.advertiser]
                    }
                }
            },
            {
                path: '/debugging/request-formulas',
                name: 'request-formulas',
                component: () => import('src/views/debugging/RequestFormulas'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
                {
                path: '/debugging/imp-buyout-info',
                name: 'imp-buyout-info',
                component: () => import('src/views/debugging/ImpBuyoutInfo'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/click-price-info',
                name: 'click-price-info',
                component: () => import('src/views/debugging/ClickPriceInfo'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/norm-coeffs',
                name: 'norm-coeffs',
                component: () => import('src/views/debugging/NormCoeffs'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/balance-hold-monitoring',
                name: 'balance-hold-monitoring',
                component: () => import('views/debugging/BalanceHoldMonitoring'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/cpa-campaigns-monitoring',
                name: 'cpa-campaigns-monitoring',
                component: () => import('views/debugging/CpaCampaignsMonitoring'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },
            {
                path: '/debugging/cpa-sources-monitoring',
                name: 'cpa-sources-monitoring',
                component: () => import('views/debugging/CpaSourcesMonitoring'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/cpa-campaigns-recovery',
                name: 'cpa-campaigns-recovery',
                component: () => import('views/debugging/CpaCampaignsRecovery'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/active-site-group',
                name: 'active-site-group',
                component: () => import('views/debugging/ActiveSiteGroup'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/active-site-group/pops',
                name: 'active-site-group-pops',
                component: () => import('views/debugging/ActiveSiteGroupPops'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/active-site-group/pops-calc',
                name: 'active-site-group-pops-calc',
                component: () => import('views/debugging/ActiveSiteGroupPopsCalc'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/active-site-group/pops-calc-log/:siteId',
                name: 'active-site-group-pops-calc-log',
                component: () => import('views/debugging/ActiveSiteGroupPopsCalcLog'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/debugging/active-site-group/pops/changes',
                name: 'active-site-group-pops-changes',
                component: () => import('views/debugging/ActiveSiteGroupChanges'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/active-site-group/monitoring',
                name: 'active-site-group',
                component: () => import('views/debugging/ActiveSiteGroupMonitoring'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/debugging/active-site-group/high-new',
                name: 'active-site-group-high-new',
                component: () => import('views/debugging/ActiveSiteGroupHighNew'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/debugging/news-tag-ctr-coeff',
                name: 'news-tag-ctr-coeff',
                component: () => import('views/debugging/NewsTagCtrCoeff'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/campaign-auto-black-by-spent',
                name: 'ampaign-auto-black-by-spent',
                component: () => import('views/debugging/CampaignAutoBlackBySpent'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/site-commission',
                name: 'site-commission',
                component: () => import('views/debugging/SiteCommission'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/dsp-site-commission',
                name: 'site-commission',
                component: () => import('views/debugging/DspSiteCommission'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/ssp-views-ttl',
                name: 'ssp-views-ttl',
                component: () => import('views/debugging/SspViewsTtl'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/resale-rejection',
                name: 'resale-rejection',
                component: () => import('views/debugging/ResaleTrafficRejection'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/site-conversion-monitoring',
                name: 'site-conversion-monitoring',
                component: () => import('views/debugging/SiteConversionMonitoring'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/push-bids-monitoring',
                name: 'push-bids-monitoring',
                component: () => import('views/debugging/PushBidsMonitoring'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/automicrobidding-monitoring',
                name: 'automicrobidding-monitoring',
                component: () => import('views/debugging/automicrobidding/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/debugging/automicrobidding-monitoring/coeffs/:campaignId',
                name: 'automicrobidding-monitoring-coeffs',
                component: () => import('views/debugging/automicrobidding/Coeffs'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },
            {
                path: '/debugging/debug-cpa-push',
                name: 'debug-cpa-push',
                component: () => import('views/debugging/DebugCpaPush'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager]
                    }
                }
            },
            {
                path: '/debugging/debug-cpa-popup',
                name: 'debug-cpa-popup',
                component: () => import('views/debugging/DebugCpaPopup'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager]
                    }
                }
            },

            {
                path: '/expense-stat',
                name: 'expense-stat',
                component: () => import('views/expenseStat/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/payouts-to-partners',
                name: 'payouts-to-partners',
                component: () => import('views/payouts/PayoutsToPartners'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/payouts-balance',
                name: 'payouts-balance',
                component: () => import('views/payouts/PayoutsBalance'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/payout-profiles',
                name: 'payout-profiles',
                component: () => import('views/payouts/PayoutProfiles'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            

            {
                path: '/imp-tags-banned',
                name: 'imp-tags-banned',
                component: () => import('views/impTagsBanned/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/promocodes-groups',
                name: 'promocodes-groups',
                component: () => import('views/promocodes/groups/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/promocodes-groups/create',
                name: 'promocodeGroup-create',
                component: () => import('views/promocodes/groups/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/promocodes-groups/:id',
                name: 'promocodeGroup-edit',
                component: () => import('views/promocodes/groups/Edit'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },
            {
                path: '/promocodes',
                name: 'promocodes',
                component: () => import('views/promocodes/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/promocodes/create',
                name: 'promocodes-create',
                component: () => import('views/promocodes/Create'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            // Менеджмент аудиторий ремаркетинга кампаний
            {
                path: '/auditories-remarketing',
                name: 'auditories-remarketing',
                component: () => import('views/auditoriesRemarketing/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            // Минимальные цены
            {
                path: '/ad-price-limits',
                name: 'ad-price-limits',
                component: () => import('views/adPriceLimits/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            // Селективные цены, создание
            {
                path: '/selective-prices-calc',
                name: 'selective-prices-calc',
                component: () => import('views/selectivePricesCalc/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            // Блэк листы, создание
            {
                path: '/black-list-calc',
                name: 'black-list-calc',
                component: () => import('views/blackListCalc/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.responsible_manager, ROLES.support]
                    }
                }
            },

            // Partner network
            {
                path: '/partner-network/statistic/',
                name: 'partner-network-statistic',
                component: () => import('views/partnerNetwork/Statistic'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/partner-network/account-matching/',
                name: 'partner-network-account-matching',
                component: () => import('views/partnerNetwork/AccountMatching'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            // Cpa models
            {
                path: '/cpa-models',
                name: 'cpa-models',
                component: () => import('views/cpaModels/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-models/create',
                name: 'cpa-model-create',
                component: () => import('views/cpaModels/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-models/edit/:id',
                name: 'cpa-model-edit',
                component: () => import('views/cpaModels/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

            // Cpa push models
            {
                path: '/cpa-push-models/:tab?',
                name: 'cpa-push-models',
                component: () => import('views/cpaPushModels/List'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-push-model-source-sets/create',
                name: 'cpa-push-model-source-set-create',
                component: () => import('views/cpaPushModels/modelSourceSet/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-push-model-source-sets/edit/:id',
                name: 'cpa-push-model-source-set-edit',
                component: () => import('views/cpaPushModels/modelSourceSet/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-push-datasets/create',
                name: 'cpa-push-dataset-create',
                component: () => import('views/cpaPushModels/modelDataset/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-push-datasets/edit/:id',
                name: 'cpa-push-dataset-edit',
                component: () => import('views/cpaPushModels/modelDataset/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-push-model/create',
                name: 'cpa-push-model-create',
                component: () => import('views/cpaPushModels/model/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/cpa-push-model/edit/:id',
                name: 'cpa-push-model-edit',
                component: () => import('views/cpaPushModels/model/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

            // Review tasks
            {
                path: '/review-tasks',
                name: 'review-tasks',
                component: () => import('views/reviewTasks/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator]
                    }
                },
            },
            {
                path: '/review-tasks/create',
                name: 'review-task-create',
                component: () => import('views/reviewTasks/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator]
                    }
                },
            },
            {
                path: '/review-tasks/edit/:id',
                name: 'review-task-edit',
                component: () => import('views/reviewTasks/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator]
                    }
                },
            },
            {
                path: '/review-tasks-results',
                name: 'review-tasks-results',
                component: () => import('views/reviewTasks/ListResults'),
                meta: {
                    auth: {
                        roles: [ROLES.admin, ROLES.moderator]
                    }
                },
            },
            {
                path: '/ads/creative-analysis',
                name: 'creative-analysis',
                component: () => import('views/ads/creativeAnalysis/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            // Open AI
            {
                path: '/open-ai',
                name: 'open-ai',
                component: () => import('views/openAi/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/open-ai/template/create',
                name: 'open-ai-template-create',
                component: () => import('views/openAi/CreateTemplate'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
            {
                path: '/open-ai/template/:id',
                name: 'open-ai-template-edit',
                component: () => import('views/openAi/EditTemplate'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
                props: true
            },

            // Integrations
            {
                path: '/integrations/push',
                name: 'integrations-push',
                component: () => import('views/integration/IntegrationManagement/ListPush'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integrations/pops',
                name: 'integrations-pops',
                component: () => import('views/integration/IntegrationManagement/ListPops'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integrations/banner',
                name: 'integrations-banner',
                component: () => import('views/integration/IntegrationManagement/ListBanner'),
                meta: { auth: { roles: [ROLES.admin] } }
            },
            {
                path: '/integration/create/:adTypeId',
                name: 'integration-create',
                component: () => import('views/integration/IntegrationManagement/Create/'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration/edit/:id',
                name: 'integration-edit',
                component: () => import('views/integration/IntegrationManagement/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration/check/:id',
                name: 'integration-check',
                component: () => import('views/integration/IntegrationManagement/Check'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integrations/check/results',
                name: 'integrations-check-results',
                component: () => import('views/integration/IntegrationManagement/CheckResults'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
             {
                path: '/integrations/check/summary',
                name: 'integrations-checks-summary',
                component: () => import('views/integration/IntegrationManagement/ChecksSummary'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration/edit-request/:id',
                name: 'integration-edit-request',
                component: () => import('views/integration/IntegrationManagement/EditRequest'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration/edit-response/:id',
                name: 'integration-edit-response',
                component: () => import('views/integration/IntegrationManagement/EditResponse'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration-test',
                name: 'integration-test',
                component: () => import('views/integration/IntegrationTest/Index.vue'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
                        {
                path: '/integration/edit-macro/:id',
                name: 'integration-edit-macro',
                component: () => import('views/integration/IntegrationManagement/EditMacro'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration/edit-smart-links/:id',
                name: 'integration-edit-smart-links',
                component: () => import('views/integration/IntegrationManagement/EditSmartLinks'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            // Integrations dsp            
            {
                path: '/integrations-dsp/pops',
                name: 'integrations-dsp-pops',
                component: () => import('views/integrationDsp/IntegrationDspManagement/ListPops'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integrations-dsp/push',
                name: 'integrations-dsp-push',
                component: () => import('views/integrationDsp/IntegrationDspManagement/ListPush'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration-dsp/create',
                name: 'integration-dsp-create',
                component: () => import('views/integrationDsp/IntegrationDspManagement/Create'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration-dsp/edit/:id',
                name: 'integration-dsp-edit',
                component: () => import('views/integrationDsp/IntegrationDspManagement/Edit'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration-dsp/edit-request/:id',
                name: 'integration-dsp-edit-request',
                component: () => import('views/integrationDsp/IntegrationDspManagement/EditRequest'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration-dsp/edit-response/:id',
                name: 'integration-dsp-edit-response',
                component: () => import('views/integrationDsp/IntegrationDspManagement/EditResponse'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },
            {
                path: '/integration-dsp-test',
                name: 'integration-dsp-test',
                component: () => import('views/integrationDsp/IntegrationDspTest/Index.vue'),
                props: true,
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                },
            },

             {
                path: '/campaign-bad-sites',
                name: 'campaign-bad-sites',
                component: () => import('views/campaignBadSites/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },

            {
                path: '/temporary-technical-work',
                name: 'pageTemporaryTechnicalWork',
                component: () => import('views/technicalWork/Alert.vue')
            },
            {
                path: '/technical-work/statuses',
                name: 'technical-work-statuses',
                component: () => import('views/technicalWork/List'),
                meta: {
                    auth: {
                        roles: [ROLES.admin]
                    }
                }
            },
        ]
    },
    {
        path: '',
        component: () => import('views/layout/Empty'),
        children: [
            {
                path: '/login',
                name: 'pageLogin',
                meta: {
                    auth: false
                },
                component: () => import('views/pages/Login.vue')
            },
            {
                path: '/logout',
                name: 'pageLogout',
                meta: {
                    auth: true
                },
                component: () => import('views/pages/Logout.vue')
            },
            {
                path: '/register',
                name: 'pageRegister',
                meta: {
                    auth: false
                },
                component: () => import('views/pages/Register.vue')
            },
            {
                path: '/confirm',
                name: 'pageConfirm',
                meta: {
                    auth: false
                },
                component: () => import('views/pages/Confirm.vue')
            },
            {
                path: '/forgot_password',
                name: 'pageForgotPassword',
                meta: {
                    auth: false
                },
                component: () => import('views/pages/ForgotPassword.vue')
            },
            {
                path: '/reset_password',
                name: 'pageResetPassword',
                meta: {
                    auth: false
                },
                component: () => import('views/pages/ResetPassword.vue')
            },
            {
                path: '/resend-register',
                name: 'resendRegister',
                meta: {
                    auth: false
                },
                props: true,
                component: () => import('views/pages/ResendRegister.vue')
            },
            {
                path: '/pages/error-404',
                name: 'pageError404',
                component: () => import('views/pages/Error404.vue')
            }
        ]
    },
    {
        path: '*',
        redirect: '/pages/error-404'
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: route
});

router.afterEach(() => {
    const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = 'none';
    }
});

export default router;
